// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sKgQE","col":"styles_col__3Iqpf"};